import { useQuery } from '@apollo/client'
import { UntitledIcon } from '@faceup/icons'
import { ulTrash03 } from '@faceup/icons/ulTrash03'
import { defineMessages, FormattedMessage } from '@faceup/localization'
import { Link, Navigate } from '@faceup/router'
import { Avatar, Button, Skeleton, Typography } from '@faceup/ui-base'
import { graphql } from '../../__generated__'
import EmailNotificationsCheckbox from '../../Components/EmailNotificationsCheckbox'
import { ReportChat } from '../../Components/ReportChat'
import { ReportSummary } from '../../Components/ReportSummary/ReportSummary'
import useReportAuth from '../../utils/useReportAuth'

const { Title } = Typography

const messages = defineMessages('followUp.pages.report', [
  { id: 'deletedTitle', defaultMessage: 'This case was deleted' },
  { id: 'deletedButton', defaultMessage: 'Go back' },
] as const)

const query = {
  ReportQuery: graphql(`
    query ReportQuery {
      companyVictimViewer {
        id
        __typename

        case {
          id
          isDeleted
        }
        ...EmailNotificationsCheckbox_viewer
      }
    }
  `),
}

const Report = () => {
  const { isAuthenticated } = useReportAuth()

  const { data } = useQuery(query.ReportQuery, {
    fetchPolicy: 'network-only',
  })

  const viewer = data?.companyVictimViewer ?? null
  const aCase = viewer?.case ?? null

  if (!viewer || !aCase) {
    return <Skeleton />
  }

  if (!isAuthenticated()) {
    return <Navigate to={routes => routes.checkReport()} replace />
  }

  if (aCase.isDeleted) {
    return (
      <div className='flex flex-col items-center gap-8'>
        <Avatar size={80}>
          <UntitledIcon size={32} icon={ulTrash03} />
        </Avatar>
        <Title level={2} className='text-center'>
          <FormattedMessage message={messages.deletedTitle} />
        </Title>
        <Link to={routes => routes.checkReport()}>
          <Button ghost type='primary'>
            <FormattedMessage message={messages.deletedButton} />
          </Button>
        </Link>
      </div>
    )
  }

  return (
    <div className='flex flex-col items-center gap-6 w-full px-8'>
      <EmailNotificationsCheckbox viewer={viewer} />
      <ReportSummary />
      <ReportChat isLoggedIn />
    </div>
  )
}

export default Report
